export default __webpack_public_path__ + "locales/el-GR/DeleteThirdPartyDialog.json?hash=c35547934a007660e3e0ad64c0d18db8";